export function numberOr(n: number | undefined | null, defaultValue = 0): number {
  return n || defaultValue
}
